import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from '@ant-design/icons';
import { DatePicker, Tooltip } from 'antd';
import i18n from '@/i18n';
import { DATE_FORMATS, isDisabledWeekendAndHoliday } from '@/utils/formUtils';

export default function CustomDatePicker({
  form,
  disabled = false,
  name = 'dateOfRequestCreate',
  allowWeekendLeaves = false,
  publicHolidays = [],
}) {
  const { t } = useTranslation(['menus', 'forms', 'messages']);

  const lang = i18n.language;

  const value = form.getFieldValue(name);

  return (
    <DatePicker
      disabled={disabled}
      value={value}
      onChange={(date) => {
        if (disabled) return;
        form.setFieldsValue({ [name]: date });
        form.onChange?.(date);
      }}
      prefix={
        <div className="relative mr-1.5">
          <Tooltip
            placement="top"
            title="Select a date to manually set the request acceptance date. Otherwise, todays date will be the request acceptance date."
          >
            <InfoCircleOutlined className="text-zinc-400" />
          </Tooltip>
        </div>
      }
      className="w-full"
      placeholder={t('formValidation.selectDate', { ns: 'forms' })}
      format={DATE_FORMATS.DISPLAY}
      disabledDate={(current) =>
        isDisabledWeekendAndHoliday(current, allowWeekendLeaves, publicHolidays)
      }
      locale={{ lang: { locale: lang } }}
    />
  );
}
